import { RootPaths } from "@src/appV2/App/paths";
import { ACCOUNTS_PATH } from "@src/appV2/redesign/Accounts/paths";

export const TIERS_PATH = "membership";
export const TIERS_FULL_PATH = `${RootPaths.APP_V2_HOME}/${ACCOUNTS_PATH}/${TIERS_PATH}`;
